// Libraries
import React from 'react';

// Supermove
import {DataLoader} from '@supermove/components';
import {gql, useQuery} from '@supermove/graphql';
import {OrganizationModel} from '@supermove/models';

// App
import NewProjectPageV1 from 'modules/Project/New/NewProjectPageV1';
import NewProjectPageV2 from 'modules/Project/New/v2/NewProjectPageV2';

const NewProjectPageWrapper = () => {
  const {data, loading} = useQuery<{organization: OrganizationModel}>(NewProjectPageWrapper.query);

  return (
    <DataLoader data={data} loading={loading}>
      {({loadedData}) => {
        if (loadedData.organization.features.isEnabledNewProjectWithConnectedCalendars) {
          return <NewProjectPageV2 />;
        }
        return <NewProjectPageV1 />;
      }}
    </DataLoader>
  );
};

NewProjectPageWrapper.query = gql`
  query NewProjectPageWrapper {
    ${gql.query}
    organization {
      id
      features {
        isEnabledNewProjectWithConnectedCalendars: isEnabled(
          feature: "NEW_PROJECT_WITH_CONNECTED_CALENDARS"
        )
      }
    }
  }
`;

export default NewProjectPageWrapper;
